import { DevicePlatform } from "@/enum/DevicePlatform";

const DEVICE_TOKEN_KEY = "DeviceToken";

export const DEVICE_PLATFORM = DevicePlatform.WEB;

const DEVICE_PLATFORM_LABELS: Record<DevicePlatform, string> = {
  [DevicePlatform.WEB]: "Web app",
  [DevicePlatform.IOS]: "iOS app",
  [DevicePlatform.ANDROID]: "Android app",
  [DevicePlatform.EXTENSION]: "Browser extension",
};

export function devicePlatformLabel(platform?: DevicePlatform): string | undefined {
  if (!platform) {
    return undefined;
  }
  return DEVICE_PLATFORM_LABELS[platform];
}

export function getDeviceToken(): string | null {
  return localStorage.getItem(DEVICE_TOKEN_KEY);
}

export function setDeviceToken(token: string) {
  localStorage.setItem(DEVICE_TOKEN_KEY, token);
}

export function getDeviceId(): string | null {
  const token = getDeviceToken();
  if (!token) {
    return null;
  }
  const dot = token.indexOf(".");
  if (dot <= 0) {
    return null;
  }
  return token.substring(0, dot);
}

export function getDeviceName(): string {
  const userAgent = navigator.userAgent;

  let browser = "Browser";
  if (userAgent.includes("Edg/")) {
    browser = "Edge";
  } else if (userAgent.includes("OPR/") || userAgent.includes("Opera")) {
    browser = "Opera";
  } else if (userAgent.includes("Chrome/")) {
    browser = "Chrome";
  } else if (userAgent.includes("Safari/")) {
    browser = "Safari";
  } else if (userAgent.includes("Firefox/")) {
    browser = "Firefox";
  }

  let os = "Unknown OS";
  if (userAgent.includes("Windows")) {
    os = "Windows";
  } else if (userAgent.includes("Mac OS X")) {
    os = "macOS";
  } else if (userAgent.includes("Android")) {
    os = "Android";
  } else if (userAgent.includes("iPhone") || userAgent.includes("iPad")) {
    os = "iOS";
  } else if (userAgent.includes("Linux")) {
    os = "Linux";
  }

  return `${browser} on ${os}`;
}
